<template>
    <MyDocuments />
</template>

<script>
import MyDocuments from "@/components/templates/MyDocuments";

export default {
  components: { MyDocuments },
};
</script>
